



















import { Vue } from "vue-property-decorator";
import type { stadium_base, stadium_curator, stadium_ground_price } from "@/@types/stadium/stadium"
import Base from "@/views/invest/form/stadium_base.vue"
import Curator from "@/views/invest/form/stadium_curator.vue"
import Notice from "@/views/invest/form/stadium_notice.vue"
import StadiumTags from "@/views/invest/form/stadium_tags.vue"
import StadiumGrounds from "@/views/invest/form/stadium_grounds.vue"
import StadiumGroundPrice from "@/views/invest/price/stadium_ground_price.vue"
import BusinessNewDay from "@/views/invest/form/business_new_day.vue"

export default Vue.extend({
  name: "StadiumBusinessInfo",
  components: {
    Base,
    Curator,
    Notice,
    StadiumTags,
    StadiumGrounds,
    StadiumGroundPrice,
    BusinessNewDay
  },
  props: {
    id: { type: String, default: "" },
  },
  data() {
    return {
      stadium: {
        id             : "",
        stadium_id     : "",
        name           : "",
        status         : "",
        status_logs    : [],
        estimate_logs  : [],
        confirm_status : "0",
        business_status: "0",
        cooperate_info : {
          stadium_notice   : "",
          stadium_tags     : [],
          business_days_new: []
        }
      } as any,
      /* 评估状态 */
      business_status: [
        { value: 0, label: "未开始", icon: "clock-circle", status: "#909399" },
        { value: 1, label: "审核中", icon: "clock-circle", status: "#10aeff" },
        { value: 2, label: "已通过", icon: "check-circle", status: "#4cd964" },
        { value: 3, label: "未通过", icon: "close-circle", status: "#f6383a" },
        { value: 4, label: "已撤销", icon: "clock-circle", status: "#909399" }
      ],
      editable            : false,
      stadium_base        : {} as stadium_base,
      stadium_curator     : {} as stadium_curator,
      stadium_ground_price: {} as stadium_ground_price,
    }
  },
  methods: {
    async get_info() {
      const params = { estimate_id: this.id }
      const res = await this.$store.dispatch("invest/stadium_info", params);
      if (res.Code == 200) {
        const data = res.Data
        if (!data.cooperate_info.business_days_new) data.cooperate_info.business_days_new = []
        this.stadium = data
        this.editable = data.business_status == "0" || data.business_status == "3"
        this.handleStadiumBase(data.cooperate_info)
        this.handleStadiumCurator(data.cooperate_info)
        this.handleStadiumTags()
        this.handleStadiumGround()
        this.handleStadiumGroundPrice(data.cooperate_info)
      }
    },
    /* 处理场馆基本信息 */
    handleStadiumBase(data: any) {
      this.stadium_base = {
        name         : data.name,
        province_id  : data.province_id,
        city_id      : data.city_id,
        county_id    : data.county_id,
        area_name    : data.area_name,
        addr         : data.addr,
        contact      : data.contact,
        sex          : data.sex,
        contact_phone: data.contact_phone,
        phone        : data.phone,
        longitude    : data.longitude,
        latitude     : data.latitude,
      }
      const base = this.$refs.base as any
      base.init()
    },
    handleStadiumCurator(data: any) {
      this.stadium_curator = {
        manager_nick  : data.manager_nick,
        manager_avatar: data.manager_avatar,
      }
    },
    handleStadiumTags() {
      const stadium_tags = this.$refs.stadium_tags as any
      stadium_tags.init()
    },
    handleStadiumGround() {
      const stadium_grounds = this.$refs.stadium_grounds as any
      stadium_grounds.init()
    },
    handleStadiumGroundPrice(data: any) {
      this.stadium_ground_price = {
        is_half_time     : data.is_half_time,
        is_people_bill   : data.is_people_bill,
        business_time    : data.business_time,
        business_time_new: data.business_time_new,
      }
      const ground_price = this.$refs.ground_price as any
      ground_price.init()
    },
    async save(params: any) {
      const res = await this.$store.dispatch("invest/save_stadium", params);
      if (res.Code == 200) {
        this.$success({
          content: "保存成功",
        })
      } else {
        this.$error({
          content: res.Message,
        })
      }
    },
    /* 提交审核 */
    submit() {
      if (this.stadium.confirm_status != "2") {
        this.$info({ content: "合作信息审核未通过，暂时无法提交！" })
        return
      }
      const base = this.$refs.base as  any
      if (!base.check()) {
        this.$info({ content: "基本信息未完整，无法提交" })
        return
      }
      const curator = this.$refs.curator as  any
      if (!curator.check()) {
        this.$info({ content: "馆长信息未完整，无法提交" })
        return
      }
      this.$confirm({
        title  : "确认提交审核？",
        content: "提交审核前，请馆长至“羽约场馆”确认营业信息无误，才可提交审核",
        onOk   : () => {
          this.$emit("submit", 2)
        }
      })
    }
  },
  watch: {
    id(id: string) {
      if (id != "0") {
        this.$nextTick(() => {
          this.get_info();
        })
      }
    }
  }
})

